<template>
    <div class="app-container mt-5">
        <div class="d-flex justify-content-between">
            <div class="page-title mb-3">
                <router-link to="/configuration">
        <span class="breadcrumb-link">
          <v-icon class="breadcrumb-link-icon">settings</v-icon> Configuration du compte
        </span>
                </router-link>
                <v-icon>keyboard_arrow_right</v-icon>
                <span class="breadcrumb-item">
        <v-icon class="breadcrumb-item-icon">format_paint</v-icon> Personnalisation des formulaires
      </span>
            </div>

            <div class="text-right">
                <v-btn
                  class="default-button"
                  @click="saveConfig"
                >
                    <v-icon>save</v-icon>
                    Enregistrer tout
                </v-btn>
            </div>
        </div>

        <v-stepper @change="setCurrentStep" non-linear :value="currentStep" class="h-auto w-auto config-stepper mb-5">
            <v-stepper-header>
                <v-stepper-step editable step="1">
                    Formulaire de Mise à jour
                </v-stepper-step>

                <v-stepper-step editable step="2"
                                v-if="account.tis_type.code === 'APIDAE' && account.configurations.aspectCampaign">
                    Formulaire de Mise à jour Aspect
                </v-stepper-step>

                <v-stepper-step editable step="3" v-if="account.tis_type.code === 'APIDAE' && isCadhAvailable()">
                    Formulaire d'Adhésion
                </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
                <v-stepper-content class="pt-0" step="1">
                    <cmaj-form-config-step
                      :provider="provider" :languages="languages" :selectedLanguages="selectedMajLanguages">
                    </cmaj-form-config-step>
                </v-stepper-content>

                <v-stepper-content class="pt-0" step="2"
                                   v-if="account.tis_type.code === 'APIDAE' && account.configurations.aspectCampaign">
                    <casp-form-config-stepper
                      :provider="provider" :languages="languages" :selectedLanguages="selectedAspLanguages">
                    </casp-form-config-stepper>
                </v-stepper-content>

                <v-stepper-content class="pt-0" step="3" v-if="account.tis_type.code === 'APIDAE' && isCadhAvailable()">
                    <cadh-form-config-stepper :token="cadhConfigToken"></cadh-form-config-stepper>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </div>

</template>

<script>
import { mapMutations, mapState } from "vuex"
import CmajFormConfigStep from "./formConfigurationSteppers/CmajFormConfigStep.vue"
import CaspFormConfigStepper from "./formConfigurationSteppers/CaspFormConfigStepper.vue"
import CadhFormConfigStepper from "./formConfigurationSteppers/CadhFormConfigStepper.vue"

export default {
    name: "Forms",
    components: { CmajFormConfigStep, CaspFormConfigStepper, CadhFormConfigStepper },
    data() {
        return {
            provider: null,
            languages: [],
            cadhConfigToken: null,
            selectedMajLanguages: [],
            selectedAspLanguages: [],
        }
    },
    methods: {
        ...mapMutations("webFormStyle", [
            "setFontFamily",
            "setTitlesColor",
            "setBackGroundColor",
            "setPrimaryColor",
            "setFieldsColor",
            "setCurrentStep",
            "setTxtIntroCmaj",
            "setFormTittleCmaj",
            "setTxtIntroCasp",
            "setCaspPrimaryColor",
            "setCaspTitlesColor",
            "setCaspFieldsColor",
            "setCaspBackGroundColor",
            "setCaspFontFamily",
            "setCadhBackGroundColor",
            "setCadhFieldsColor",
            "setCadhFontFamily",
            "setCadhPrimaryColor",
            "setCadhTitlesColor",
            "setLastCadhConfigToken",
        ]),
        saveConfig() {
            if(typeof this.backGroundColor !== 'object') {
                this.setBackGroundColor(this.rgbaStringToObject(this.backGroundColor))
            }

            if(typeof this.caspBackGroundColor !== 'object') {
                this.setCaspBackGroundColor(this.rgbaStringToObject(this.caspBackGroundColor))
            }

            if(typeof this.cadhBackGroundColor !== 'object') {
                this.setCadhBackGroundColor(this.rgbaStringToObject(this.cadhBackGroundColor))
            }

            let payload = {
                txtIntro: this.txtIntroCmaj,
                fontFamily: this.fontFamily,
                primaryColor: this.primaryColor,
                titleColor: this.titlesColor,
                fieldColor: this.fieldsColor,
                backGroundColor: this.backGroundColorRgba,
                formTittle: this.formTittleCmaj,
                txtIntroCasp: this.txtIntroCasp,
                caspFontFamily: this.caspFontFamily,
                caspTitlesColor: this.caspTitlesColor,
                caspBackGroundColor: this.caspBackGroundColorRgba,
                caspPrimaryColor: this.caspPrimaryColor,
                caspFieldsColor: this.caspFieldsColor,
                cadhFontFamily: this.cadhFontFamily,
                cadhTitlesColor: this.cadhTitlesColor,
                cadhBackGroundColor: this.cadhBackGroundColorRgba,
                cadhPrimaryColor: this.cadhPrimaryColor,
                cadhFieldsColor: this.cadhFieldsColor,
            }

            this.$global.loading = true

            this.$http.post("auth/account/form-config", payload).then((res) => {
                this.$global.loading = false
            })
        },
        getLanguages() {
            this.$http.get("resource/languages").then((res) => {
                this.languages = res.body.data.languages

                this.selectedMajLanguages = this.languages.slice(0, 3)
                this.selectedAspLanguages = this.languages.slice(0, 3)
            })
        },
        getFirstAccountProvider() {
            this.$http.get("auth/account/first-provider").then((res) => {
                this.provider = res.body.data.provider
            })
        },
        getWebFormConfig() {
            this.$http.get("auth/account/web-form-config").then((res) => {
                let config = res.body.data.config

                if (config !== null) {
                    this.setFontFamily(config.font_family)
                    this.setPrimaryColor(config.primary_color)
                    this.setBackGroundColor(this.rgbaStringToObject(config.background_color))
                    this.setFieldsColor(config.field_color)
                    this.setTitlesColor(config.title_color)
                    this.setCaspFontFamily(config.casp_font_family !== null ?
                      config.casp_font_family : "Roboto, sans-serif")
                    this.setCaspPrimaryColor(config.casp_primary_color !== null ?
                      config.casp_primary_color : "#1398b5")
                    this.setCaspBackGroundColor(config.casp_background_color !== null ?
                      this.rgbaStringToObject(config.casp_background_color) :
                      this.rgbaStringToObject("rgba(245, 245, 245, 1)"))
                    this.setCaspFieldsColor(config.casp_field_color !== null ?
                      config.casp_field_color : "#787d8f")
                    this.setCaspTitlesColor(config.casp_title_color !== null ? config.casp_title_color : "#000000")
                    this.setCadhFontFamily(config.cadh_font_family !== null ?
                      config.cadh_font_family : "Roboto, sans-serif")
                    this.setCadhPrimaryColor(config.cadh_primary_color !== null ?
                      config.cadh_primary_color : "#1398b5")
                    this.setCadhBackGroundColor(config.cadh_background_color !== null ?
                      this.rgbaStringToObject(config.cadh_background_color) :
                      this.rgbaStringToObject("rgba(245, 245, 245, 1)"))
                    this.setCadhFieldsColor(config.cadh_field_color !== null ?
                      config.cadh_field_color : "#787d8f")
                    this.setCadhTitlesColor(config.cadh_title_color !== null ? config.cadh_title_color : "#000000")
                    this.cadhConfigToken = res.body.data.cadhConfigToken
                }
                else {
                    this.setBackGroundColor(this.rgbaStringToObject(this.backGroundColor))
                    this.setCaspBackGroundColor(this.rgbaStringToObject(this.caspBackGroundColor))
                    this.setCadhBackGroundColor(this.rgbaStringToObject(this.cadhBackGroundColor))
                }
            })
        },
        rgbaStringToObject(backGroundColor) {
            let colors = ["r", "g", "b", "a"]

            let colorArr = backGroundColor.slice(backGroundColor.indexOf("(") + 1, backGroundColor.indexOf(")")).split(",")

            let obj = {}

            colorArr.forEach((k, i) => {
                obj[colors[i]] = k
            })

            return obj
        },
        isCadhAvailable() {
            let available = false
            let contracts = this.account.current_contracts

            if (contracts.length) {
                contracts.forEach(contract => {
                    let module = contract.contract_offer.options.filter(option => option.code === "CADH")
                    if (module.length) {
                        available = true
                    }
                })
            }
            return available
        },
    },
    computed: {
        ...mapState("account", ["account"]),
        ...mapState("webFormStyle", [
            "fontFamily",
            "titlesColor",
            "backGroundColor",
            "primaryColor",
            "fieldsColor",
            "currentStep",
            "formTittleCmaj",
            "txtIntroCmaj",
            "availableFonts",
            "caspFontFamily",
            "caspTitlesColor",
            "caspBackGroundColor",
            "caspPrimaryColor",
            "caspFieldsColor",
            "txtIntroCasp",
            "cadhBackGroundColor",
            "cadhTitlesColor",
            "cadhPrimaryColor",
            "cadhFieldsColor",
            "cadhFontFamily",
        ]),
        backGroundColorRgba() {
            return (
              "rgba(" +
              this.backGroundColor.r +
              "," +
              this.backGroundColor.g +
              "," +
              this.backGroundColor.b +
              "," +
              this.backGroundColor.a +
              ")"
            )
        },
        caspBackGroundColorRgba() {
            return (
              "rgba(" +
              this.caspBackGroundColor.r +
              "," +
              this.caspBackGroundColor.g +
              "," +
              this.caspBackGroundColor.b +
              "," +
              this.caspBackGroundColor.a +
              ")"
            )
        },
        cadhBackGroundColorRgba() {
            return (
              "rgba(" +
              this.cadhBackGroundColor.r +
              "," +
              this.cadhBackGroundColor.g +
              "," +
              this.cadhBackGroundColor.b +
              "," +
              this.cadhBackGroundColor.a +
              ")"
            )
        },
    },
    created() {
        let txtIntro = this.account.configurations.txtIntro
        let formTittle = this.account.configurations.formTittle
        let txtIntroAspect = this.account.configurations.txtIntroAspect
        this.setCurrentStep("1")

        if (txtIntro !== null) {
            this.setTxtIntroCmaj(txtIntro.value)
        }

        if (formTittle !== null) {
            this.setFormTittleCmaj(formTittle.value)
        }

        if (txtIntroAspect !== null) {
            this.setTxtIntroCasp(txtIntroAspect.value)
        }

        this.getLanguages()
        this.getFirstAccountProvider()
        this.getWebFormConfig()
    },
}
</script>
